<template>
  <div id="subscriptionapp">
    <SingleTrailSubscription msg="Welkom in de subscription app!"/>
  </div>
</template>

<script>
import SingleTrailSubscription from './components/SingleTrailSubscription.vue';

export default {
  name: 'SubscriptionApp',
  components: {
    SingleTrailSubscription,
  },
};
</script>

<style scoped>
</style>
